import { useEffect } from "react";

import { Outlet, useLocation, useNavigate } from "react-router";

import { useAuth } from "../context/Auth/AuthProvider";
import TwoFactorRequirement from "../Pages/Auth/components/TwoFactorRequirement/TwoFactorRequirement";
import { ROUTES } from "../shared";
import { getEnvironment } from "../shared/functions/functions";

const ProtectedRoute = () => {
  const { user, tokenInfo } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();
  const { isDevelopmentEnv } = getEnvironment();

  useEffect(() => {
    if (!tokenInfo) {
      navigate(ROUTES.Home, {
        state: {
          from: {
            pathname: location.pathname,
            search: location.search
          }
        },
        replace: true
      });
    }
  }, [location, navigate, user, tokenInfo]);

  if (tokenInfo && !user.twoFactorEnabled && !isDevelopmentEnv) {
    return <TwoFactorRequirement />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
